import React from 'react';
import bannerStyle from './style';

export default function Banner({bgImage, title, addonStyle = {}, alignment = 'left', mt}) {
	let style = bannerStyle();
	return (
		<div
			style={{
				...style.outerStyle({mt: mt}),
				...addonStyle,
			}}
		>
			<img style={style.image()} src={bgImage} />
			<h2 style={style.titleStyle({alignment: alignment})}>{title}</h2>
		</div>
	);
}
